import { makeStyles } from '@material-ui/core/styles';
import { MAX_WIDTH_SEMI_XL } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    iframeContainer: {
      'flex-shrink': '0',
      position: 'relative',
      maxWidth: `${MAX_WIDTH_SEMI_XL}px`,
      transition: 'width 0.3s',
      display: 'flex',
    },
    powerAppResizableWrapper: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
    },
    powerAppResizableButton: {
      position: 'absolute',
      right: muiTheme.spacing(-7),
      top: muiTheme.spacing(0),
    },
  }),
  { name: 'ResizableContainer' },
);

export default useStyles;
